import WellTemplate from '../../html/components/well.html'
import WellHeaderTemplate from '../../html/components/well-header.html'
import WellContentTemplate from '../../html/components/well-content.html'

import Component from '../shared/component'

export const Well = Component('v-well', {
  template: WellTemplate
})

export const WellHeader = Component('v-well-header', {
  template: WellHeaderTemplate
})

export const WellContent = Component('v-well-content', {
  template: WellContentTemplate
})
